import { Outlet } from 'react-router-dom'
import AdminNavbar from '../Admin/Components/AdminNavbar'
import AdminSidebar from '../Admin/Components/AdminSidebar'
import '../Admin/AdminCss.css'

function AdminLayout() {
  return (
    <div className='LoggedInContainer'>
      <AdminSidebar />
      <AdminNavbar />
      <div className='Admin-page'>
        <Outlet />
      </div>
    </div>
  )
}

export default AdminLayout
